﻿import $ from 'jquery';

declare global {
  interface JQueryStatic {
    _data: (element: HTMLElement, event: string) => Array<any>; 
  }
}

export class SuppressesEvent {


  public execute(event: string, element: HTMLElement | JQuery, action: () => void): void {
      if (!event) {
        throw new Error('event is required');
    }

    if (element instanceof HTMLElement)
      element = $(element);

    let preventEvent = function (e) {
      e.stopImmediatePropagation();
      return false;
    };

    element.on(event, preventEvent);
    let events = $._data(element[0], "events")[event.split('.')[0]];
    events.unshift(events.pop());
    let addedEvent = events[0];

    try {
      action();
    }
    finally {
      let index = events.indexOf(addedEvent);
      events.splice(index, 1);
    }
  }
}

export default SuppressesEvent;
